import { Tab, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { AvailableReportsTable } from "features/reports/available-reports/AvailableReportsTable";
import { HistoricalReportsTable } from "features/reports/historical-reports/HistoricalReportsTable";
import { useTranslation } from "react-i18next";
import { QueryBoundary } from "shared/api/QueryBoundary";
import PageBody from "shared/components/layout/PageBody";
import PageContainer from "shared/components/layout/PageContainer";
import PageContent from "shared/components/layout/PageContent";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTabs } from "shared/components/table/box/TableBoxTabs";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";
import useDocumentPoll from "shared/hooks/useDocumentPoll";
import useDocumentTitle from "shared/hooks/useDocumentTitle";
import { StringParam, useQueryParam } from "use-query-params";

const TABLE_TABS = ["available", "historical"];

export const ReportsTablePage: React.FC = () => {
  const { t } = useTranslation(["reports", "common"]);

  useDocumentTitle(t("common:reports"));

  const [selectedTab, setSelectedTab] = useQueryParam("tab", StringParam);

  const { setDocumentId } = useDocumentPoll(
    t("reports:reportGenerationSucceeded"),
    t("reports:reportGenerationFailed"),
    t("reports:downloadingReport"),
  );

  // Default to the first tab by using Math.max to ensure we don't get a negative index
  const currentTabIndex = Math.max(
    TABLE_TABS.findIndex((v) => v == selectedTab),
    0,
  );

  return (
    <PageContainer>
      <PageContent hasHeader={false} isFullHeight={true}>
        <PageBody>
          <TableBox key={currentTabIndex}>
            <TableBoxHeader>
              <TableBoxTabs
                index={currentTabIndex}
                onChange={(index) => setSelectedTab(TABLE_TABS[index])}
              >
                <Tab>{t("reports:available")}</Tab>
                <Tab>{t("reports:historical")}</Tab>
              </TableBoxTabs>
              <DataTableBoxActions />
            </TableBoxHeader>
            <TableBoxBody>
              <Tabs variant="table" index={currentTabIndex} isLazy={true}>
                <TabPanels>
                  <TabPanel>
                    <QueryBoundary>
                      <AvailableReportsTable
                        onSuccess={(data) => {
                          setDocumentId(data.document_id);
                        }}
                      />
                    </QueryBoundary>
                  </TabPanel>
                  <TabPanel>
                    <QueryBoundary>
                      <HistoricalReportsTable />
                    </QueryBoundary>
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </TableBoxBody>
          </TableBox>
        </PageBody>
      </PageContent>
    </PageContainer>
  );
};
